import Vue from 'vue/dist/vue.esm'

function isSupported(storage) {
  try {
    const key = "__some_random_key_for_testing__";
    storage.setItem(key, key);
    storage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
}

if (isSupported(localStorage)) {
  window.POC.sidebar = {
    collapsed: localStorage.getItem('sidebarCollapsed') === '1',
  };

  $(function () {
    const $sidebar = $('.sidebar');

    if (!$sidebar) return;

    if (POC.sidebar.collapsed) {
      $sidebar.addClass('sidebar-collapsed');
    }

    $('#sidebar-toggle').on('click', function (e) {
      e.preventDefault();
      POC.sidebar.collapsed = !POC.sidebar.collapsed;
    });

    new Vue({
      data: {
        sidebar: window.POC.sidebar,
      },
      watch: {
        'sidebar.collapsed': function (val) {
          localStorage.setItem('sidebarCollapsed', val ? '1' : '0');
          if (val) {
            $sidebar.addClass('sidebar-collapsed');
          } else {
            $sidebar.removeClass('sidebar-collapsed');
          }
        }
      }
    });
  });
}


